import React, { useEffect, useState } from 'react';
import styles from './ManagePlanAndPaymentBanner.module.scss';
import { BigButton, ModalButtonArea } from '../../common';
import { WarningContentInfoIcon } from '../../assets/icons';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import PaymentDoneIcon from '../../components/icons/PaymentDone';
import {
  selectDefaultPaymentMethod,
  selectUserActivePlanDetails,
} from '../../redux/slicers/subscriptionSlicer';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { SETTINGS_ROUTE } from '../../constants/routePathConstants';
import {
  SETTINGS_TAB,
  TEXTURE_BASE_TYPE,
  THREE_3D_MODAL_BASE_TYPE,
} from '../../constants/constants';
import { Link } from 'react-router-dom';
import useSubscriptionPurchase from '../../hooks/useSubscriptionPurchase';
import {
  ADD_ONS_PRODUCT_BASE_NAME,
  PLAN_ITEM_NAMES,
  RECURRING_INTERVAL,
  convertStripeCentsToAmount,
  getDateFromTimestamp,
} from './subscriptionHelper';
import { handleScrollToTop } from '../../helpers/jsHelper';
import {
  UpgradeToNewPlanPatchV2,
  setClientSubscriptionPlansV2,
} from '../../api/subscription/subscription';
import useAddOnsInfo from '../../hooks/useAddOnsInfo';

export const CancelSubscription = (props) => {
  const subscriptionList = props?.subscriptionList || [];
  const enableConfirmBtn = props?.subscriptionList?.some(({ selected }) => selected);

  const handlePlanTotalAmount = (data) => {
    let total = 0;
    total =
      +total +
      +data?.editor?.price_amount *
        (data?.editor?.product_quantity + data?.editor?.to_remove_product_quantity || 1);
    total = +total + +data?.modalLimit?.price_amount;
    total = +total + +data?.textureLimit?.price_amount;
    return total;
  };

  const handleGetTotalAmount = () => {
    let total = 0;
    subscriptionList?.map((list) => {
      if (list?.isCreatorPlan) {
        total = +total + +handlePlanTotalAmount(list?.counts);
      } else {
        total = +total + +list?.price_amount * (list?.product_quantity || 1);
      }
    });
    return convertStripeCentsToAmount(total);
  };

  return (
    <div className={styles.cancelYourSubscription}>
      <p>
        <WarningContentInfoIcon />
      </p>
      <h2>Cancel Subscription</h2>

      <div className={styles.subDescription}>
        <p>You have multiple items added to your subscription plan.</p>
        <p>Please select the items you want to cancel:</p>
      </div>
      <div className={styles.subscriptionListContainer}>
        {!subscriptionList?.length && (
          <div className="d-flex justify-content-center">
            <span>No data available.</span>
          </div>
        )}
        <ul className={styles.subscriptionList}>
          {subscriptionList?.length > 0 && (
            <li key={'all'}>
              <input
                type="checkbox"
                checked={
                  subscriptionList?.length ===
                  props?.subscriptionList?.filter(({ selected }) => selected)?.length
                }
                name="inverted1"
                onChange={() => props?.handleSelectedSubscription?.()}
              />
              <p>
                <span className={styles.NameAndPrice}>
                  {' '}
                  <span>Select All</span>{' '}
                  <span className={styles.itemRightAmount}>${handleGetTotalAmount()}</span>{' '}
                </span>
              </p>
            </li>
          )}
          {subscriptionList?.map((org, index) => {
            let countsInfo = org?.isCreatorPlan ? (
              <span className={styles?.subText}>
                Models <b>{org?.counts?.modalLimit?.item_counts?.total_count || 5}</b>, Textures{' '}
                <b>{org?.counts?.textureLimit?.item_counts?.total_count || 10}</b>, Editor
                <b>
                  {+(
                    org?.counts?.editor?.product_quantity +
                    org?.counts?.editor?.to_remove_product_quantity
                  ) || 1}
                </b>
              </span>
            ) : null;
            return (
              <>
                <li key={org?.id}>
                  <input
                    type="checkbox"
                    checked={org?.selected}
                    name="inverted1"
                    onChange={() => props?.handleSelectedSubscription?.(org?.indexVal)}
                  />
                  <p>
                    <span className={styles.NameAndPrice}>
                      {' '}
                      <span>
                        {org?.name}{' '}
                        {`${RECURRING_INTERVAL.MONTH === org?.interval ? '- Monthly' : '- Yearly'}`}
                      </span>{' '}
                      <span className={styles.itemRightAmount}>
                        $
                        {convertStripeCentsToAmount(
                          org?.isCreatorPlan
                            ? handlePlanTotalAmount(org?.counts)
                            : org?.price_amount * (+org?.product_quantity || 1)
                        )}
                      </span>{' '}
                    </span>
                    {countsInfo}
                  </p>
                </li>
              </>
            );
          })}
        </ul>
      </div>
      <div className={styles.bottomDescription}>
        <p>If you cancel Creator plan, all upgrades to your model, texture, and</p>
        <p>editor limits will be removed.</p>
        <p>
          To downgrade, go to{' '}
          <span onClick={() => props?.handleCancel(true)} className={styles.redirectText}>
            Manage Subscription
          </span>
          .
        </p>
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`lf-btn-1 keep-text ${styles.confirm}`}
          onClick={props?.handleCancelSubscription}
          buttonTitle="Confirm"
          isLoading={props?.submitLoader}
          disabled={!enableConfirmBtn}
        />
        <BigButton
          className={`lf-btn-3 keep-text ${styles.cancel}`}
          onClick={props?.handleCancel}
          buttonTitle="Cancel"
        />
      </div>
    </div>
  );
};

export default function ManagePlanAndPaymentBanner(props) {
  const dispatch = useDispatch();
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const { userPlans } = useSubscriptionPurchase();
  const { filterAddonsList } = useAddOnsInfo();
  const [open, setOpen] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [showLabel, setShowLabel] = useState(false);
  const defaultPaymentMethod = useSelector(selectDefaultPaymentMethod);
  const activePlan = useSelector(selectUserActivePlanDetails);

  useEffect(() => {
    if (userPlans?.length && open) {
      handleFilterSubscriptionList(userPlans);
    }
  }, [userPlans?.length, open]);

  useEffect(() => {
    if (userPlans?.length) {
      handleFilterSubscriptionList(userPlans,true);
    }else{
      showLabel && setShowLabel(false)
    }
  }, [userPlans?.length, open, filterAddonsList]);

  const handleFilterSubscriptionList = (data = userPlans,isShowLabel) => {
    const creatorPlanBaseTypes = [
      TEXTURE_BASE_TYPE,
      THREE_3D_MODAL_BASE_TYPE,
      ADD_ONS_PRODUCT_BASE_NAME.Editor,
    ];

    const planInfoFlag = {
      [RECURRING_INTERVAL.MONTH]: { isDefaultPlan: false, isCreatorPlanAvailable: false },
      [RECURRING_INTERVAL.YEAR]: { isDefaultPlan: false, isCreatorPlanAvailable: false },
    };

    const activePlans =
      data?.filter((plan) => !plan.is_cancelled && plan?.status !== 'deleted') || [];

    // Update the creator plan availability
    activePlans.forEach((plan) => {
      const intervalFlag = planInfoFlag[+plan?.recurring_interval];
      if (!intervalFlag.isCreatorPlanAvailable) {
        if (plan?.plan_details?.some(({ is_custom_plan }) => is_custom_plan)) {
          intervalFlag.isCreatorPlanAvailable = true;
        }
      }
    });

    const list = [];

    // Populate the subscription list
    activePlans.forEach((plan) => {
      const intervalFlag = planInfoFlag[+plan?.recurring_interval];
      const planDetails = plan?.plan_details || [];

      if (intervalFlag.isCreatorPlanAvailable) {
        const textureLimit = planDetails.find(
          ({ basemodeltype }) => basemodeltype === TEXTURE_BASE_TYPE
        );
        const modalLimit = planDetails.find(
          ({ basemodeltype }) => basemodeltype === THREE_3D_MODAL_BASE_TYPE
        );
        const editor = planDetails.find(
          ({ basemodeltype }) => basemodeltype === ADD_ONS_PRODUCT_BASE_NAME.Editor
        );
        intervalFlag.isDefaultPlan = true;

        if (
          +modalLimit?.product_quantity > 0 &&
          +editor?.product_quantity > 0 &&
          +textureLimit?.product_quantity > 0
        ) {
          list.push({
            counts: { modalLimit, textureLimit, editor },
            isCreatorPlan: true,
            interval: plan?.recurring_interval,
            name: 'Creator Plan',
            parentData: plan,
            indexVal: list?.length + 1,
          });
        }
        const addPlanDetails = (planItem) => {
          if (
            intervalFlag.isDefaultPlan &&
            !creatorPlanBaseTypes.includes(planItem?.basemodeltype) &&
            +planItem?.product_quantity > 0
          ) {
            list.push({
              ...planItem,
              interval: plan?.recurring_interval,
              name: PLAN_ITEM_NAMES[planItem?.basemodeltype] || planItem?.basemodeltype,
              parentData: plan,
              indexVal: list?.length + 1,
            });
          }
        };

        planDetails.forEach(
          intervalFlag.isDefaultPlan
            ? addPlanDetails
            : (planItem) => {
                if (+planItem?.product_quantity > 0) {
                  list.push({
                    ...planItem,
                    interval: plan?.recurring_interval,
                    name: PLAN_ITEM_NAMES[planItem?.basemodeltype] || planItem?.basemodeltype,
                    parentData: plan,
                    indexVal: list?.length + 1,
                  });
                }
              }
        );
      } else {
        planDetails.forEach((planItem) => {
          if (planItem?.product_quantity > 0) {
            list.push({
              ...planItem,
              interval: plan?.recurring_interval,
              name: PLAN_ITEM_NAMES[planItem?.basemodeltype] || planItem?.basemodeltype,
              parentData: plan,
              indexVal: list?.length + 1,
            });
          }
        });
      }
    });
    // get creator plan entry on first list.
    const sortedData = list?.sort((a, b) => {
      if (a?.isCreatorPlan && !b?.isCreatorPlan) return -1;
      if (!a?.isCreatorPlan && b?.isCreatorPlan) return 1;
      return 0;
    });
    if(isShowLabel){
      setShowLabel(sortedData?.length ? true : false)
    }else{
      setSubscriptionList(sortedData);
    }
  };

  const handleClose = (isScrollTop) => {
    setOpen(false);
    setSubmitLoader(false);
    setSubscriptionList([]);
    if (isScrollTop) {
      handleScrollToTop();
    }
  };

  const handleCancelSubscription = (selectedItems) => {
    const isCreatorPlan = selectedItems?.find(({ isCreatorPlan }) => isCreatorPlan);
    const addonsItems = selectedItems?.filter(({ isCreatorPlan }) => !isCreatorPlan);
    const isSingleItem = addonsItems?.length === 1;
    setOpen(false);

    const handleList = () => {
      return (
        <ul className="mt-2">
          {addonsItems?.map((addonsInfo) => {
            return (
              <li>
                <b>{addonsInfo?.basemodeltype}</b>: Active until{' '}
                <b>
                  {getDateFromTimestamp(addonsInfo?.parentData?.current_period_end_timestamp, true)}
                </b>
              </li>
            );
          })}
        </ul>
      );
    };
    openInfoDialog({
      children: (
        <div className={styles.cancelYourSubscription}>
          <p>
            <PaymentDoneIcon />
          </p>
          <h2>Subscription canceled</h2>
          <div className={styles.subDescription}>
            {isCreatorPlan ? (
              !addonsItems?.length ? (
                <p>
                  Your{' '}
                  {+isCreatorPlan?.interval === RECURRING_INTERVAL.MONTH ? 'Monthly' : 'Yearly'}{' '}
                  Creator plan subscriptions have been canceled. It will remain active until{' '}
                  <span>
                    {getDateFromTimestamp(
                      isCreatorPlan?.parentData?.current_period_end_timestamp,
                      true
                    )}
                  </span>{' '}
                  and will not renew automatically.
                </p>
              ) : (
                <p>
                  Your{' '}
                  {+isCreatorPlan?.interval === RECURRING_INTERVAL.MONTH ? 'Monthly' : 'Yearly'}{' '}
                  Creator plan and the following add-ons have been canceled.
                  {handleList()}
                  They will remain active until their respective end dates and will not renew
                  automatically
                </p>
              )
            ) : isSingleItem ? (
              <p>
                Your {addonsItems?.[0]['basemodeltype']} -{' '}
                {+addonsItems?.[0]?.interval === RECURRING_INTERVAL.MONTH ? 'Monthly' : 'Yearly'}{' '}
                Add-on subscription has been canceled. It will remain active until{' '}
                <span>
                  {getDateFromTimestamp(
                    addonsItems?.[0]?.parentData?.current_period_end_timestamp,
                    true
                  )}
                </span>{' '}
                and will not renew automatically.
              </p>
            ) : (
              <>
                {addonsItems?.length === 2 && (
                  <p>
                    Your{' '}
                    {addonsItems?.map((item, index) => {
                      return index + 1 === addonsItems?.length
                        ? ` & ${item?.['basemodeltype']}`
                        : `${item?.['basemodeltype']}`;
                    })}{' '}
                    have been canceled:
                    {handleList()}
                    They will remain active until their respective end dates and will not renew
                    automatically.
                  </p>
                )}

                {addonsItems?.length > 2 && (
                  <p>
                    Your{' '}
                    {addonsItems?.slice(0, 3)?.map((item, index) => {
                      return index + 1 === addonsItems?.slice(0, 3)?.length
                        ? ` and the following add-ons have been canceled:`
                        : ` ${item?.['basemodeltype']},`;
                    })}{' '}
                    {handleList()}
                    They will remain active until their respective end dates and will not renew
                    automatically.
                  </p>
                )}
              </>
            )}
          </div>
          <div className={styles.actionButtonContainer}>
            <BigButton
              className={`lf-btn-1 keep-text ${styles.confirm}`}
              onClick={() => {
                closeInfoDialog();
                props?.setModifySubscription?.();
              }}
              buttonTitle="Okay"
            />
          </div>
        </div>
      ),
    });
  };

  const handleSelectedSubscription = (selectedId) => {
    const cloneSubscriptionList = subscriptionList.slice();
    if (!selectedId) {
      const list = subscriptionList.filter((list) => list?.selected === true)?.length;
      const selectAll = subscriptionList?.length === list;
      subscriptionList.map((list, index) => {
        cloneSubscriptionList[index]['selected'] = !selectAll;
      });
      setSubscriptionList(cloneSubscriptionList);
      return;
    }
    const findIndex = cloneSubscriptionList.findIndex(({ indexVal }) => +indexVal === +selectedId);
    if (~findIndex) {
      cloneSubscriptionList[findIndex]['selected'] = cloneSubscriptionList[findIndex].selected
        ? false
        : true;
    }
    setSubscriptionList(cloneSubscriptionList);
  };

  const cancelSelectedItemsFromPlan = async () => {
    const selectedItems = subscriptionList?.filter(({ selected }) => selected);
    const groupedItems = {
      [RECURRING_INTERVAL.MONTH]: selectedItems?.filter(
        ({ interval }) => +interval === RECURRING_INTERVAL.MONTH
      ),
      [RECURRING_INTERVAL.YEAR]: selectedItems?.filter(
        ({ interval }) => +interval === RECURRING_INTERVAL.YEAR
      ),
    };
    const processItems = async (items, interval) => {
      if (!items?.length) return null;

      const subscriptionId = items?.[0]?.parentData?.id;
      if (!subscriptionId) return null;

      const payload = {
        add_subscription_items: false,
        data: [],
      };

      items.forEach((item) => {
        if (item?.isCreatorPlan) {
          if (item?.counts?.editor && item?.counts?.editor?.product_quantity > 0) {
            payload.data.push({
              remove_item_id: item?.counts?.editor?.price_stripe_price_id,
              remove_item_quantity: item?.counts?.editor?.product_quantity,
            });
          }
          if (item?.counts?.modalLimit) {
            payload.data.push({
              remove_item_id: item?.counts?.modalLimit?.price_stripe_price_id,
              remove_item_quantity: 1,
            });
          }
          if (item?.counts?.textureLimit) {
            payload.data.push({
              remove_item_id: item?.counts?.textureLimit?.price_stripe_price_id,
              remove_item_quantity: 1,
            });
          }
        } else {
          if (item?.product_quantity > 0) {
            payload.data.push({
              remove_item_id: item?.price_stripe_price_id,
              remove_item_quantity: item?.product_quantity || 1,
            });
          }
        }
      });
      return { res: await UpgradeToNewPlanPatchV2(payload, subscriptionId), interval };
    };
    setSubmitLoader(true);
    const results = await Promise.all([
      processItems(groupedItems[RECURRING_INTERVAL.MONTH], RECURRING_INTERVAL.MONTH),
      processItems(groupedItems[RECURRING_INTERVAL.YEAR], RECURRING_INTERVAL.YEAR),
    ]);
    setSubmitLoader(false);
    const successResponses = results.filter((result) => result?.res);
    if (successResponses.length) {
      dispatch(setClientSubscriptionPlansV2());
      handleCancelSubscription(selectedItems);
    }
  };

  if (!activePlan?.id || !defaultPaymentMethod || !showLabel) return null;
  return (
    <div className={styles.bannerContainer}>
      <p>
        {' '}
        Your current plan will renew on the {_.capitalize(defaultPaymentMethod?.card_brand)} ending
        in {defaultPaymentMethod?.last4}. You can
        <Link to={`${SETTINGS_ROUTE}?activeTab=${SETTINGS_TAB.BILLING}`}>
          {' '}
          manage your payment methods
        </Link>{' '}
        or <span onClick={() => setOpen(true)}>cancel your subscription.</span>
      </p>
      <ModalButtonArea
        size={'md'}
        startOpen={open}
        showModal={open}
        setShowModal={handleClose}
        centered={true}
        className={`${styles.registerFlowContainer} ${props?.dialogClassName} ${
          props?.applyBg ? styles.applyBgColor : ''
        }`}
        bigButton={false}
        bigIcon={true}
        variant="link"
        hideCloseButton={true}
        backdropClassName="overlay-dark"
        headingLeft
        body={
          <>
            <CancelSubscription
              subscriptionList={subscriptionList}
              submitLoader={submitLoader}
              handleCancelSubscription={() => {
                cancelSelectedItemsFromPlan();
              }}
              handleCancel={handleClose}
              handleSelectedSubscription={handleSelectedSubscription}
            />
          </>
        }
      />
    </div>
  );
}
